"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var _ref = _react.default.createElement("div", {
  className: "margin-bottom-3"
}, _react.default.createElement("strong", null, "Calico"), _react.default.createElement("br", null), "1170 Veterans Boulevard", _react.default.createElement("br", null), "South San Francisco, CA 94080");

var _ref2 = _react.default.createElement("div", null, _react.default.createElement("span", {
  className: "margin-right-2 inline-block"
}, "\xA9\xA0Copyright 2018 Calico\xA0LLC (d/b/a Calico Group LLC)"), _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "calicolabs.com"), _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/privacy-policy/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "Privacy Policy"), _react.default.createElement("a", {
  className: "margin-right-2 inline-block grey-l",
  href: "https://www.calicolabs.com/code-of-conduct/",
  rel: "noopener noreferrer",
  target: "_blank"
}, "Code of Conduct"));

var CalicoResearchFooter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CalicoResearchFooter, _React$Component);

  function CalicoResearchFooter() {
    (0, _classCallCheck2.default)(this, CalicoResearchFooter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CalicoResearchFooter).apply(this, arguments));
  }

  (0, _createClass2.default)(CalicoResearchFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style;
      return _react.default.createElement("footer", {
        className: (0, _classnames.default)('calico-research-footer', className),
        style: style
      }, children && _react.default.createElement("div", {
        className: "margin-bottom-3"
      }, children), _ref, _ref2);
    }
  }]);
  return CalicoResearchFooter;
}(_react.default.Component);

var _default = CalicoResearchFooter;
exports.default = _default;